import React, { useState } from 'react';

const faqs = [
  {
    question: 'How do I install a Watchi face?',
    answer: 'Open the face in Watchi, tap "Add to Smart Watch", and it appears in the Watch app on your iPhone — synced and ready in seconds.',
  },
  {
    question: 'Will animated faces drain my battery?',
    answer: 'All animations are tuned for Always-On Display and tested across Smart Watch models to stay battery-friendly.',
  },
  {
    question: 'Can I schedule faces automatically?',
    answer: 'Yes. Premium members set faces to follow Focus modes or time-based routines — the right look at the right moment, no manual switching.',
  },
  {
    question: 'Do I keep my faces if I cancel?',
    answer: 'Downloaded faces stay on your Watch. New drops and automatic sync features require an active subscription.',
  },
  {
    question: 'Which Smart Watch models are supported?',
    answer: 'Watchi supports Smart Watch Series 4 and later running watchOS 10+. Most features require Series 7+ for Always-On Display.',
  },
];

const FAQ: React.FC = () => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="py-24"
      style={{
        background: 'linear-gradient(180deg, #080C0B 0%, #0A1210 100%)',
      }}
    >
      <div className="container mx-auto">
        <div className="text-center mb-14">
          <span className="section-badge mb-4 inline-flex">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#68C1AE]" />
            FAQ
          </span>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight" style={{ letterSpacing: '-0.03em' }}>
            Questions,{' '}
            <span className="gradient-text">answered.</span>
          </h2>
          <p className="mt-4 text-base text-white/40">
            Still curious? Email us at{' '}
            <a href="mailto:support@watchi.app" className="text-[#68C1AE] hover:underline underline-offset-2 transition">
              support@watchi.app
            </a>
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="rounded-2xl overflow-hidden transition-all duration-300"
                style={{
                  background: isOpen ? 'rgba(104,193,174,0.06)' : 'rgba(255,255,255,0.03)',
                  border: isOpen ? '1px solid rgba(104,193,174,0.25)' : '1px solid rgba(255,255,255,0.07)',
                }}
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  <span className="text-[15px] font-semibold text-white pr-4">{faq.question}</span>
                  <span
                    className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300"
                    style={{
                      background: isOpen ? '#68C1AE' : 'rgba(255,255,255,0.08)',
                      transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                    }}
                  >
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M5 1v8M1 5h8" stroke={isOpen ? '#080C0B' : '#ffffff'} strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-6 pb-6 text-[15px] text-white/55 leading-relaxed animate-fade-in-up">
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
